// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: true,
//   baseApiUrl: 'http://localhost:3000/',
//   mapbox: {
//     accessToken:
//       'pk.eyJ1IjoiaW50dWl0aXZlYmFkZ2VyIiwiYSI6ImNrOXZpeXZiNzBkN3Iza29saHhjOWo2OGwifQ.QOMbmOzi8OhYw6NYyDqBRQ',
//   },
//   cesium: {
//     // accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhMzc3MDU4OS0wOGZkLTRlNjUtOTg0Ny0yMTgxY2QzMzFlYjYiLCJpZCI6Mzc0NDYsImlhdCI6MTYwNTA2NTAwMn0.QBVysuBtwTPBW5WsRwZ1uol3gIxTX12sQc3MrDlJwqM',
//     accessToken:
//       'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMzE4MDQ5MS01ZGQ5LTQ4Y2YtYjM2NC0xN2M3ZjVkNDJhYzEiLCJpZCI6MzM3MTgsImlhdCI6MTYwMzI5MDEyNH0.-DXOwYMj_Uh_GEvB1tXNRShH7AmcK3rouQAEKZi6POQ',
//   },
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


export const environment = {
  production: false,
  baseApiUrl: 'https://suntory.vertikaliti.com:3000/',
  mapbox: {
    accessToken:
      'pk.eyJ1IjoiaW50dWl0aXZlYmFkZ2VyIiwiYSI6ImNrOXZpeXZiNzBkN3Iza29saHhjOWo2OGwifQ.QOMbmOzi8OhYw6NYyDqBRQ',
  },
  cesium: {
    // accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhMzc3MDU4OS0wOGZkLTRlNjUtOTg0Ny0yMTgxY2QzMzFlYjYiLCJpZCI6Mzc0NDYsImlhdCI6MTYwNTA2NTAwMn0.QBVysuBtwTPBW5WsRwZ1uol3gIxTX12sQc3MrDlJwqM',
    accessToken:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMzE4MDQ5MS01ZGQ5LTQ4Y2YtYjM2NC0xN2M3ZjVkNDJhYzEiLCJpZCI6MzM3MTgsImlhdCI6MTYwMzI5MDEyNH0.-DXOwYMj_Uh_GEvB1tXNRShH7AmcK3rouQAEKZi6POQ',
  },
  websocketUrl: 'https://suntory.vertikaliti.com:3000'
};
